var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlHead4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 558,
    viewBox: "0 0 530 558",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl / Head / 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hair color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    d: "M502.781 227.38C502.781 242.6 501.201 257.46 498.179 271.799C477.721 369.44 391.121 402.76 287.381 402.76C168.439 402.76 71.999 346.34 71.999 227.38C71.999 108.42 168.439 11.9995 287.381 11.9995C369.159 11.9995 440.301 57.5595 476.781 124.7C493.359 155.22 502.781 190.2 502.781 227.38Z",
    fill: "#F6B852"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 11,
    width: 432,
    height: 392
  }, /*#__PURE__*/React.createElement("path", {
    id: "Hair_2",
    d: "M502.781 227.38C502.781 242.6 501.201 257.46 498.179 271.799C477.721 369.44 391.121 402.76 287.381 402.76C168.439 402.76 71.999 346.34 71.999 227.38C71.999 108.42 168.439 11.9995 287.381 11.9995C369.159 11.9995 440.301 57.5595 476.781 124.7C493.359 155.22 502.781 190.2 502.781 227.38Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.316 370.68C324.316 370.68 298.454 371.444 287.432 365.422L322.942 387.718L324.316 370.68Z",
    fill: "#CF3E83"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Face color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Face",
    d: "M315.671 207.189C340.857 228.855 378.135 249.002 421.896 262.7C419.11 292.35 409.859 343.452 381.954 362.014C368.772 370.78 344.766 371.86 324.316 370.68L319.626 428.766L258.84 404.96C258.84 404.96 274.012 334.364 265.888 321.39C254.978 303.912 225.788 298.28 225.754 274.126C225.742 266.972 229.924 254.586 245.366 254.562C266.094 254.532 263.14 279.364 263.14 279.364C282.208 286.781 301.643 235.974 315.671 207.189V207.189Z",
    fill: "#5E93D1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.533 279.318L395.333 315.198L378.163 314.854L380.533 279.318Z",
    fill: "#2437A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.777 280.874C364.407 288.042 360.193 293.626 355.361 293.348C350.529 293.07 346.911 287.034 347.279 279.866C347.649 272.698 351.865 267.112 356.695 267.39C361.527 267.67 365.147 273.706 364.777 280.874Z",
    fill: "#1D1D23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.15 279.729C409.78 286.897 405.566 292.481 400.734 292.203C395.902 291.925 392.284 285.889 392.654 278.721C393.024 271.553 397.238 265.967 402.07 266.247C406.902 266.525 410.52 272.561 410.15 279.729Z",
    fill: "#1D1D23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 15",
    d: "M373.951 332.041C373.951 332.041 362.763 335.651 351.553 323.187",
    stroke: "#24242B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    opacity: 0.399019,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.273 370.679C324.273 370.679 298.411 371.443 287.389 365.423L322.899 387.717L324.273 370.679Z",
    fill: "black"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlHead4);
export default __webpack_public_path__ + "static/media/Girl-Head-4.6b786cdf.svg";
export { ForwardRef as ReactComponent };